import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { ThemeProvider, Typography, createTheme } from '@mui/material';
import Captcha from './Captcha';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 380,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
    p: 3,
    outline: 'none',
};

export default function CaptchaModal({ openCaptcha, handleCloseCaptcha, captchaValue }) {
    const theme = createTheme({
        palette: {
            mode: 'dark',
            // background: {
            //     paper: '#0f172a',
            // },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <Modal
                open={openCaptcha}
                onClose={handleCloseCaptcha}
                closeAfterTransition
                disableEscapeKeyDown
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                        sx: {
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            backdropFilter: 'blur(4px)',
                        },
                    },
                }}
            >
                <Fade in={openCaptcha}>
                    <Box sx={modalStyle}>
                        <Typography
                            variant="h6"
                            align="center"
                            sx={{
                                mb: 1,
                                fontWeight: 600,
                                letterSpacing: 0.5,
                                color: 'rgba(255,255,255,0.9)',
                            }}
                        >
                            Verify You’re Human 🤖
                        </Typography>

                        <Typography
                            variant="body2"
                            align="center"
                            sx={{
                                mb: 3,
                                color: 'rgba(255,255,255,0.7)',
                            }}
                        >
                            Please complete the captcha to continue
                        </Typography>

                        <Captcha captchaValue={captchaValue} handleCloseCaptcha={handleCloseCaptcha} />
                    </Box>
                </Fade>
            </Modal>
        </ThemeProvider>
    );
}
